// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import AppearanceControls from './appearance/AppearanceControls';

import HomePage from './pages/HomePage';
import LandingPage from './pages/LandingPage';
import ChemicalPage from './pages/ChemicalPage';
import BiologicalPage from './pages/BiologicalPage';
import RadiationNuclearPage from './pages/RadiationNuclearPage';
import TBOutbreakPage from './pages/TBOutbreakPage';

import PrivateRoute from './auth/PrivateRoute';
import AppLayout from './components/layout/AppLayout';

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TrainingJobWatcher from "./TrainingJobWatcher";

export default function App() {
  return (
    <Router>
      <TrainingJobWatcher />
      <AppearanceControls />

      <ToastContainer
        position="bottom-right"
        autoClose={false}
        closeOnClick={false}
        pauseOnHover={true}
        draggable={false}
        newestOnTop={true}
      />

      <Routes>
        {/* public (login) */}
        <Route path="/" element={<HomePage />} />

        {/* AppLayout (hamburger + sidebar) */}
        <Route element={<AppLayout />}>
          <Route
            path="/landing"
            element={
              <PrivateRoute>
                <LandingPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/chemical"
            element={
              <PrivateRoute>
                <ChemicalPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/biological"
            element={
              <PrivateRoute>
                <BiologicalPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/radiationnuclear"
            element={
              <PrivateRoute>
                <RadiationNuclearPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/tb-outbreak"
            element={
              <PrivateRoute>
                <TBOutbreakPage />
              </PrivateRoute>
            }
          />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<HomePage />} />
      </Routes>
    </Router>
  );
}